import React, { createContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const TrustedCollegeContext = createContext();

const TrustedCollegeProvider = ({ children }) => {
  const [trustedColleges, setTrustedColleges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get('/api/colleges')
      .then((res) => {
        setTrustedColleges(res.documents);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <TrustedCollegeContext.Provider value={{ trustedColleges, loading, error }}>
      {children}
    </TrustedCollegeContext.Provider>
  );
};

export { TrustedCollegeContext, TrustedCollegeProvider };
